import { useContext, useMemo } from 'react';
import { MTDialog } from '@/components/common/MTDialog';
import { MapWrapper } from '@/components/Map/MapWrapper';
import { COMMON_STRING } from '@/constants/dictionary';
import { ActionDialogProps } from '@/components/ActionsDialog/types';
import { ScoringContext } from '@/contexts/scoring/context';

export const LocationDialog = ({ action, onClose }: ActionDialogProps) => {
  const {
    fixtureConfigState: { fixtureConfig },
  } = useContext(ScoringContext);

  const venueLocation = useMemo(
    () =>
      fixtureConfig &&
      fixtureConfig?.fixture.venue.location?.longitude &&
      fixtureConfig?.fixture.venue.location?.latitude
        ? {
            lat: fixtureConfig.fixture.venue.location.latitude,
            lng: fixtureConfig.fixture.venue.location.longitude,
            label: COMMON_STRING.VENUE_LOCATION,
          }
        : undefined,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      fixtureConfig?.fixture.venue.location?.latitude,
      fixtureConfig?.fixture.venue.location?.longitude,
    ],
  );

  const deviceLocation = {
    lat: action!.metadata!.latitude,
    lng: action!.metadata!.longitude,
    label: COMMON_STRING.DEVICE_LOCATION,
  };

  return (
    <MTDialog
      open={true}
      onClose={onClose}
      title={COMMON_STRING.DEVICE_LOCATION}
      maxWidth='xl'
      fullWidth
    >
      <MapWrapper coordinates={{ deviceLocation, venueLocation }} />
    </MTDialog>
  );
};
